import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderFooterLayout from '../components/header-footer-layout';
import GreyBorderedBox from '../components/grey-bordered-box';
import BulletList from '../components/bullet-list';
import NoticeSection from '../components/notice-section';
import TitleBox from '../components/title-box';
import styles from '../styles/faq.module.scss';

const Faq: FC = () => {
    const navigate = useNavigate();

    return (
        <HeaderFooterLayout title="よくあるご質問（FAQ）" onHome={() => navigate('/bookings/new/')}>
            <div className={styles.faq}>
                <img
                    className={styles.storeImage}
                    src="/static/img/usol_repair/storefront.png"
                    alt="スマホ修理工房"
                />
                <div className={styles.faqSection}>
                    <TitleBox title="よくあるご質問（FAQ）" />
                    <GreyBorderedBox className={styles.faqBox}>
                        <NoticeSection title="【ご来店時のお持ちもの】">
                            <BulletList>
                                <li>修理するスマートフォン</li>
                                <li>
                                    ご本人確認書類（運転免許証・マイナンバーカードなど）
                                    <br />
                                    ※代理の方は「委任状」もお持ちください
                                    <br />
                                    <a
                                        className={styles.faqLink}
                                        href="https://www.au.com/support/service/common/document-dl/#anc01"
                                        target="_blank"
                                    >
                                        https://www.au.com/support/service/common/document-dl/#anc01
                                    </a>
                                </li>
                            </BulletList>
                        </NoticeSection>
                        <NoticeSection title="【ご来店前のお願い】">
                            <BulletList>
                                <li>
                                    データは事前にバックアップをお取りください。お客さまのスマートフォンの故障状況などによりデータ初期化が必要となる場合がございます。店頭ではバックアップを行うことはできません。
                                </li>
                                <li>ご予約時間にあわせてご来店ください。</li>
                                <li>
                                    ご予約時間に遅れそうな場合は、事前に店舗へご連絡ください。
                                    <br />
                                    ※ご予約時間から15分以上経過した場合、当日の状況によりご案内時間を変更させていただく場合がございます。
                                </li>
                            </BulletList>
                        </NoticeSection>
                        <NoticeSection title="【修理代金】">
                            <BulletList>
                                <li>
                                    故障紛失サポート ワイド with Cloud／故障紛失サポート with
                                    Cloud／故障紛失サポートにご加入中のお客さまは、上限金額5,500円＋利用料1,100円となります。
                                </li>
                                <li>
                                    故障紛失サポートに未加入のお客さまは、修理費用（実費）＋利用料1,100円となります。
                                    <br />
                                    ※表記の金額すべて税込です。
                                </li>
                            </BulletList>
                        </NoticeSection>
                    </GreyBorderedBox>
                </div>
            </div>
        </HeaderFooterLayout>
    );
};

export default Faq;
